import React from "react";
import classnames from "classnames";
import { Tooltip } from "@ad/anq-ui";
import {
  DirectionArrowUp,
  DirectionArrowDown,
  PromptQuestionCircleFill,
} from "@/Icons";
import { renderCentPrice, renderNumber } from "@/common/render";
import { isNullOrEmpty } from "@/common/util/helpers";
import { CardItem } from "../common";
import { QueryBusinessDataResult } from "@/api/business_gmv/interface";

interface Props {
  items: CardItem[];
  selectedKey: string;
  onSelect: (key: string) => void;
  dataSource: QueryBusinessDataResult;
  hideSelectBar?: boolean;
  className?: string;
  col?: number;
}

// https://tailwindcss.com/docs/content-configuration#dynamic-class-names
const gridColsMap = {
  3: "grid-cols-3",
  4: "grid-cols-4",
  5: "grid-cols-5",
};

/** 生意模块的左侧部分, 后续等巡检的需求上线替换成components下那个组件 */
const DataOverviewCard = ({
  items,
  selectedKey,
  onSelect,
  dataSource,
  hideSelectBar,
  className,
  col = 5,
}: Props) => {
  const renderData = (cardItem: CardItem) => {
    const data = dataSource?.[cardItem.key];

    if (cardItem.isPrice) {
      return renderCentPrice(data);
    }

    return renderNumber(data);
  };

  return (
    <div className={classnames(className, "grid gap-2", gridColsMap[col])}>
      {items.map((item) => (
        <div
          key={item.key}
          className={classnames(
            "relative cursor-pointer rounded bg-white p-4 duration-200 hover:bg-[#F5F6FA]",
            {
              ["bg-gradient-to-b from-[#EDF2FF] to-[#F7FAFF]"]:
                selectedKey === item.key,
            }
          )}
          onClick={() => onSelect(item.key)}
        >
          <div
            className={classnames("relative flex items-center", {
              ["before:absolute before:left-[-12px] before:top-0 before:h-5 before:w-1 before:rounded-r-[2px] before:bg-text-blue before:content-['']"]:
                selectedKey === item.key && !hideSelectBar,
            })}
          >
            <span className="text-xs">{item.title}</span>
            <Tooltip title={item.notice} trigger="hover">
              <PromptQuestionCircleFill className="ml-[2px] text-[14px] text-question" />
            </Tooltip>
          </div>
          <div
            className={classnames("mt-1 font-semibold", {
              ["text-[rgba(76,103,255,0.95)]"]: selectedKey === item.key,
            })}
          >
            <span className="text-lg">{renderData(item)}</span>
            {item.isPrice && <span className="ml-1 leading-[0px]">元</span>}
          </div>
          <div className="mt-[10px] flex text-xs text-text-black/[.5]">
            <span>较上一周期</span>
            {isNullOrEmpty(dataSource?.[item.changeKey]) ? (
              <span className="ml-[2px]">-</span>
            ) : (
              <span
                className={classnames(
                  dataSource?.[item.changeKey] > 0
                    ? "text-[#ff2424]"
                    : "text-[#00B42B]",
                  "ml-[2px] flex items-center"
                )}
              >
                {dataSource?.[item.changeKey] > 0 && <DirectionArrowUp />}
                {dataSource?.[item.changeKey] < 0 && <DirectionArrowDown />}
                <span className="ml-[2px]">
                  {(dataSource?.[item.changeKey] as number) / 100}%
                </span>
              </span>
            )}
          </div>
        </div>
      ))}
    </div>
  );
};

export default DataOverviewCard;
